import React, {useContext, useState, useEffect} from 'react';
import './login.css';
import Box from '@mui/material/Box';
import AppLayout from 'components/AppLayout/AppLayout';
import {ReactComponent as WiseviewLogo} from 'assets/wiseview-logo.svg';
import {ReactComponent as WiseviewLogoDark} from 'assets/resilient_logo_dark.svg';

import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import { toast } from 'react-toastify';
import Container from '@mui/material/Container';

import { DataContext } from 'contexts/DataContext';
import { login } from 'utils/api';
import { getProfile } from 'utils/api';
import { useNavigate } from 'react-router-dom';

function Login() {
    const dataContext = useContext(DataContext);
    const [error] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);

        var loginResponse = null
        loginResponse = await login(data.get('email')?.toString() || '',data.get('password')?.toString() || '');    
        if(loginResponse.token) {
            dataContext.changeToken(loginResponse.token || '');
            
            const user = await getProfile();
            dataContext.changeUser(user);
            //let beforeLogin = sessionStorage.getItem('beforeLogin')
            //sessionStorage.removeItem('beforeLogin');
            //navigate(beforeLogin || '/home');

            navigate('/home');

        } else {
            //setError(loginResponse.message);
            toast.error(loginResponse.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              });
          }
    };

    useEffect(()=>{
        if(dataContext.loading) return;
        //If already loggd in, redirect to home
        if(dataContext.token) {
            navigate('/home');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[dataContext.loading, dataContext.token]);


  return (
    <AppLayout drawerOpen={true} appBar={false}>
        <Box className={dataContext.darkMode ? 'login login-dark' : 'login login-light'}>

        <Container component="main" maxWidth="sm">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '30px',
            borderRadius: '10px',
            border: (theme) => `1px solid ${theme.palette.mode === 'dark'
              ? theme.palette.divider
              : 'rgba(0, 0, 0, 0.12)'}`,
            backgroundColor: (theme) => theme.palette.background.paper,
          }}
        >
        {dataContext.darkMode ? (
          <WiseviewLogoDark />
        ) : (
          <WiseviewLogo />
        )}

          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 0 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
            />
            <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember me"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Sign In
            </Button>

            <Grid container>
              <Grid item xs>
                <div style={{color:'rgb(237, 138, 25)',marginTop:'10px'}}>{error}</div>
              </Grid>
            </Grid>

            {false && 
            <Grid container>
              <Grid item xs>
                <Link href="#" variant="body2">
                  Forgot password?
                </Link>
              </Grid>
              <Grid item>
                <Link href="#" variant="body2">
                  {"Don't have an account? Sign Up"}
                </Link>
              </Grid>
            </Grid>}
          </Box>
        </Box>
      </Container>



        </Box>
    </AppLayout>
  );
}

export default Login;
